export const fakeLogin = {
    bookingnumber: '300139561',
    lastname: 'Swiftcruise',
    travelstart: '23.05.2025',
};
export default fakeLogin;
